// @ts-nocheck
/* eslint-disable */
export const menuIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 4H21V6H3V4ZM3 11H15V13H3V11ZM3 18H21V20H3V18Z" fill="currentColor"/></svg>`,
  name: 'menu' as const,
};
